import React from "react";
import "./SalesDisplay.css";
import { useStoreSettings } from "../../../../../hooks/useStoreSettings";
import useCurrency from "../../../../../hooks/useCurrency";

const SalesDisplay = ({
    originalPrice,
    discountedPrice,
    hasDiscount,
    className = "",
    size = "large" // "large" for product detail, "small" for grid
}) => {
    const { currency: storeCurrency } = useStoreSettings();
    const { formatDisplay, getCurrency } = useCurrency();

    if (!hasDiscount) {
        return (
            <div className={`sales-display no-discount ${size} ${className}`}>
                <div className="price-display">
                    <span className="current-price">{formatDisplay(originalPrice)}</span>
                </div>
            </div>
        );
    }

    return (
        <div className={`sales-display with-discount ${size} ${className}`}>
            {/* Discount Badge */}

            {/* Price Display */}
            <div className="price-display">
                <span className="original-price">{formatDisplay(originalPrice)}</span>
                <span className="discounted-price">{formatDisplay(discountedPrice)}</span>
            </div>

            {/* Sale Description */}
            {/* {saleDescription && (
                <div className="sale-description">{saleDescription}</div>
            )} */}



        </div>
    );
};

export default SalesDisplay;